import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../../context/admin";
import AdminService from "../../../../services/admin.service";
import Modal from "../../../common/Modal";
import { useGlobal } from "../../../../context/global";

export default function ConfirmDeletePendingPayment() {
    const { setIsLoading } = useGlobal()
    const { confirmDeletePendingPaymentId, setConfirmDeletePendingPaymentId } = useAdmin()

    async function onDelete(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.deleteCashPendingPayment(confirmDeletePendingPaymentId!)
            window.location.reload()
        } catch (error: any) {
            alert(error?.response?.data || 'No se pudo eliminar el pago pendiente')
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Modal onSubmit={onDelete}>
            <h1>Eliminar pago pendiente</h1>
            <p>¿Seguro que quieres eliminar este pago pendiente? Esta acción no se puede deshacer.</p>
            <div className="actions" style={{ margin: '15px 0' }}>
                <button className="delete">Eliminar</button>
            </div>
            <div className="close" onClick={() => setConfirmDeletePendingPaymentId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}
